import { render, staticRenderFns } from "./FootNav.vue?vue&type=template&id=01b7d120&scoped=true&"
import script from "./FootNav.vue?vue&type=script&lang=js&"
export * from "./FootNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b7d120",
  null
  
)

export default component.exports